"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var _Site = require("../Site.config");
const useStyles = (isMobileView, isGuestUser) => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const numOfToolbarColumns = isMobileView ? isGuestUser ? 3 : 2 : 5;
  const ccHeaderStyle = (0, _react.useMemo)(() => {
    const ccHeader = (0, _css.css)({
      fontFamily,
      fontSize: pxToRem(16),
      backgroundColor: themeColors?.general.light,
      position: 'fixed',
      display: 'flex',
      boxSizing: 'border-box',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: pxToRem(_Site.headerHeight),
      padding: `0 ${pxToRem(10)}`,
      top: 0,
      left: 0,
      zIndex: 5
    });
    const ccHeaderLogo = (0, _css.css)({
      position: 'relative',
      height: '80%',
      display: 'flex',
      alignItems: 'center',
      img: {
        position: 'relative',
        height: '100%'
      }
    });
    const ccHeaderSpacer = (0, _css.css)({
      width: 0,
      height: pxToRem(26),
      display: 'inline-block',
      fontSize: 0,
      borderLeft: `solid ${pxToRem(2)} ${themeColors?.general.subText}`,
      opacity: 0.3,
      marginRight: pxToRem(10)
    });
    const ccHeaderLogoLink = {
      height: '100%'
    };
    const ccHeaderToolbar = (0, _css.css)({
      display: 'grid',
      gridAutoFlow: 'column',
      alignItems: 'center',
      columnGap: pxToRem(isMobileView ? 8 : 12),
      '>*': {
        display: 'inline-flex'
      }
    });
    const ccHeaderUserRole = (0, _css.css)({
      color: themeColors?.primary.main,
      display: 'flex',
      justifyContent: 'space-between',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      backgroundColor: 'transparent',
      border: 'none',
      alignItems: 'center',
      borderRadius: 0,
      lineHeight: '1'
    });
    const ccHeaderUserRoleButton = (0, _css.css)({
      display: 'inline-flex',
      alignItems: 'center',
      columnGap: pxToRem(8),
      color: themeColors?.primary.main,
      fontWeight: 'bold'
    });
    const ccHeaderUserRoleText = (0, _css.css)({
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: pxToRem(100)
    });
    const ccHeaderLangButtonLabel = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      gap: pxToRem(5)
    });
    const ccHeaderLoginButton = (0, _css.css)({
      gridColumn: isMobileView ? `${numOfToolbarColumns} / ${numOfToolbarColumns}` : undefined,
      '> button': {
        fontWeight: 'bold'
      }
    });
    const ccHeaderProfileButton = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      marginInlineStart: pxToRem(15),
      gap: pxToRem(2)
    });
    const ccHeaderProfileButtonName = (0, _css.css)({
      lineHeight: '1'
    });
    const ccHeaderLangButton = (0, _css.css)({
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer'
    });
    const ccHeaderLangImage = (0, _css.css)({
      ...(isMobileView && {
        width: pxToRem(30),
        height: pxToRem(30)
      })
    });
    const ccHeaderProfilePopupTitle = (0, _css.css)({
      fontSize: pxToRem(20),
      fontWeight: 'bold',
      margin: `${pxToRem(5)} ${pxToRem(10)}`
    });
    const ccHeaderTopMarker = (0, _css.css)({
      display: 'block',
      width: '100%',
      height: 0,
      position: 'absolute',
      bottom: 0
    });
    return {
      ccHeader,
      ccHeaderLogo,
      ccHeaderLogoLink,
      ccHeaderToolbar,
      ccHeaderSpacer,
      ccHeaderUserRole,
      ccHeaderUserRoleButton,
      ccHeaderUserRoleText,
      ccHeaderLoginButton,
      ccHeaderLangButtonLabel,
      ccHeaderProfileButton,
      ccHeaderProfileButtonName,
      ccHeaderLangButton,
      ccHeaderLangImage,
      ccHeaderProfilePopupTitle,
      ccHeaderTopMarker
    };
  }, [isMobileView, numOfToolbarColumns, fontFamily, themeColors?.general.light, themeColors?.general.subText, themeColors?.primary.main, pxToRem]);
  return {
    'cc-Header': ccHeaderStyle.ccHeader,
    'cc-Header__logo': ccHeaderStyle.ccHeaderLogo,
    'cc-Header__logo__link': ccHeaderStyle.ccHeaderLogoLink,
    'cc-Header__toolbar': ccHeaderStyle.ccHeaderToolbar,
    'cc-Header__toolbar__spacer': ccHeaderStyle.ccHeaderSpacer,
    'cc-Header__toolbar__user-role': ccHeaderStyle.ccHeaderUserRole,
    'cc-Header__toolbar__user-role__button': ccHeaderStyle.ccHeaderUserRoleButton,
    'cc-Header__toolbar__user-role__text': ccHeaderStyle.ccHeaderUserRoleText,
    'cc-Header__toolbar__login-button': ccHeaderStyle.ccHeaderLoginButton,
    'cc-Header__toolbar__lang-button-label': ccHeaderStyle.ccHeaderLangButtonLabel,
    'cc-Header__toolbar__profile__button': ccHeaderStyle.ccHeaderProfileButton,
    'cc-Header__toolbar__profile__button__name': ccHeaderStyle.ccHeaderProfileButtonName,
    'cc-Header__toolbar__lang-button': ccHeaderStyle.ccHeaderLangButton,
    'cc-Header__toolbar__lang-image': ccHeaderStyle.ccHeaderLangImage,
    'cc-Header__profile-popup__title': ccHeaderStyle.ccHeaderProfilePopupTitle,
    'cc-Header__TopMarker': ccHeaderStyle.ccHeaderTopMarker
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;